module.exports = "/_next/static/images/098487f6796acecec98972b4529dd846-Nubank_HickDuarte_54700_xs.jpg";